import { render, staticRenderFns } from "./picdescdialog.vue?vue&type=template&id=249b04db&scoped=true&"
import script from "./picdescdialog.vue?vue&type=script&lang=js&"
export * from "./picdescdialog.vue?vue&type=script&lang=js&"
import style0 from "./picdescdialog.vue?vue&type=style&index=0&id=249b04db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b04db",
  null
  
)

export default component.exports